module.exports = {"title":"Tickets Assignment","both":"Both","boxOfficeOnly":"Box office only","noOne":"No one","saveClose":"Save and Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateFlexpass/FlexpassDatesModal/locales/fr.json
// module id = 1727
// module chunks = 0